import React from 'react';
import { StyledFrame } from './app-frame.styles';
export const AppFrame = ({ children }) => (<StyledFrame>{children}</StyledFrame>);
export default AppFrame;
